import React, { useState, useContext, useEffect } from 'react';

import {  Row, Col, CardDeck } from "react-bootstrap";

import CardInfo from '../../components/Card-Info/card-info';
import Loading from '../../components/Loading';
import ModalInfo from './modal-info';

import BenefitsContext from "../../context/Benefits/BenefitsContext";

const Benefits = () => {

    const benefitsContext = useContext(BenefitsContext);
    const {loading, benefits, loadBenefits} = benefitsContext;

    const [ benefit, setBenefit ] = useState();

    useEffect(() => {        
        const load = () => {
            loadBenefits()
        }
        if(!benefits || benefits.length === 0){ load() }
       // eslint-disable-next-line
    }, []);

    const handleSelectedBenefit = (title, resume, expirationDate) => {
        let selected = benefits.find(element => (element.title === title || element.title === resume || element.title === expirationDate ))
        setBenefit(selected);
    }
    
    return ( 
        <>
            <Row>
                <Col>
                    <h1 className="h3 mb-2 text-gray-800">Beneficios</h1>
                    <hr />
                </Col>
            </Row>
            { loading ? 
                <Loading /> :
                <CardDeck>
                        {benefits.map(  (benefit, index) =>  {
                        return (
                                <CardInfo 
                                    key={index} 
                                    title={benefit.title} 
                                    resume={benefit.resume} 
                                    expirationDate={benefit.expirationDate} 
                                    setData={handleSelectedBenefit}
                                />
                            )
                        }
                    )}
                </CardDeck>
            }
        {!benefit ? 
            null : 
            <ModalInfo 
                title={benefit.title} 
                information={benefit.information} 
                eventaData={setBenefit}
                />
            }
        </>
     );
}
 
export default Benefits;